var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/buffer/~/isarray/index.js
// module id = 1038
// module chunks = 0